import DOMPurify from 'dompurify';

export default (el, binding) => {
  // eslint-disable-next-line no-param-reassign
  el.innerHTML = DOMPurify.sanitize(binding.value);
};
